import { getHeaderThunk } from './auth-reducer.ts';

const SET_INITIALIZE = 'SET_INITIALIZE';

export type initialStateType = {
    initialized: boolean
}

let initialState: initialStateType = {
    initialized: false,
}

const appReducer = (state = initialState, action: any): initialStateType => {
    switch (action.type) {
        case SET_INITIALIZE: {
            return {
                ...state,
                initialized: true,
            }
        }
    default:
        return state;
    }
}

type initializedSuccessActionType = {
    type: typeof SET_INITIALIZE
}

export const initializedSuccess = (): initializedSuccessActionType => ({type: SET_INITIALIZE});

export const initializeApp = () => (dispatch: any) => {
        let promise = dispatch(getHeaderThunk());
        Promise.all([promise]).then(() => {
            dispatch(initializedSuccess());
        });
    }

export default appReducer;